var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-button",
    {
      staticClass: "md-primary md-just-icon md-round",
      class:
        _vm.disableActionButtons &&
        _vm.disableUploadAttachmentButton(_vm.blockoutDay)
          ? "md-disabled"
          : "",
      attrs: {
        title: "Upload Attachments",
        disabled:
          _vm.disableActionButtons &&
          _vm.disableUploadAttachmentButton(_vm.blockoutDay),
      },
      on: {
        click: function ($event) {
          return _vm.handleAddBlockoutDayAttachment(_vm.blockoutDay)
        },
      },
    },
    [_c("md-icon", [_vm._v("attach_file")])],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }